import { IIsiUIFlowResult } from "../Core/IIsiUIFlowResult";
import { IsiPresentationLogic } from "./IsiPresentationLogic";
import { IsiButtonType, IsiModeConfirm, IsiIconType } from "../../Isilog.enums";

/**
 * Gestion de l'action "supprimer" sur le menu des DA 
 * */
export class IsiPlRestore extends IsiPresentationLogic {

    constructor() {
        super("IsiPlRestoreHandler");
    }

    /**
     * demande la confirmation de suppression
     */
    public restoreOnDetail(): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            window.sCodeLibelleStatus = LOADING;

            uiCore.showConfirm({
                message: uiCore.getMessage("DARMess", "Restaure").IsiLabel,
                iconType: IsiIconType.Question,
                confirmMode: IsiModeConfirm.YesNo,
                callback: function (reponse) {
                    resolve({ result: true, continue: reponse === IsiButtonType.Yes });
                }
            });
        });
    }
    
}